import { pick } from 'lodash-es';
import { MANDATORY_CARD_FIELDS } from 'consts';

export const ACTIVATE_CARD_ISSUING_FORM_FIELDS = {
  ...pick(MANDATORY_CARD_FIELDS, 'number')
};
